module.exports = __webpack_public_path__ + "img/StainleeSteelProducts1.5ecd3f96.jpg";